module.exports = __webpack_public_path__ + "img/loans.1a690ab7.png";